export default "__VITE_ASSET__DcWy0nrG__"